<template>
  <form
    class="space-y-6"
    novalidate
    @submit="onFormElementSubmit"
  >
    <FormInputText
      name="email"
      type="email"
      autocomplete="email"
      label="Email Address"
    />

    <FormInputPassword
      name="password"
      label="Password"
      autocomplete="current-password"
    />

    <div class="flex items-center justify-between">
      <RouterLink
        :to="{
          name: 'resetPasswordRequest',
          params: { userType: 'merchant-group-admin' },
        }"
        class="text-sm text-primary hover:text-primary/70"
      >
        Forgot password?
      </RouterLink>
      <FormSubmitButton
        :is-submitting="isSubmitting"
        type="submit"
      >
        Sign in with password
      </FormSubmitButton>
    </div>
  </form>
</template>

<script setup lang="ts">
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import z from "zod"
import {
  emailAddressSchema,
  requiredNonBlankString,
} from "@/validation/sharedStringFieldSchemas"

const router = useRouter()

const formSchema = z.object({
  email: emailAddressSchema("Email is required"),
  password: requiredNonBlankString("Password is required"),
})

const { handleSubmit, isSubmitting } = useForm({
  validationSchema: toTypedSchema(formSchema),
})

const onFormElementSubmit = handleSubmit(async (values) => {
  try {
    await logInMerchantGroupAdmin(values)

    router.push({
      name: "merchantGroupDashboard",
    })
  } catch {
    toast.error(
      "Failed to log in. Please check your username and password are correct."
    )
  }
})
</script>
